// import { baseApi } from "./baseApi";

// export interface Service {
//   id: string;
//   description: string;
//   price: string;
//   base_price: string;
//   vehicle_type: string;
//   price_model: string;
//   from: string;
//   to: string;
//   service_type_name: string;
//   service_type_id: string;
//   created_at: string;
//   status?: string;
//   staff_members_id?: string[];
// }

// export interface GetAllServicesResponse {
//   data: Service[];
//   links: {
//     first: string;
//     last: string;
//     prev: string | null;
//     next: string | null;
//   };
//   meta: {
//     current_page: number;
//     from: number;
//     last_page: number;
//     path: string;
//     per_page: number;
//     to: number;
//     total: number;
//   };
// }

// export interface ServiceType {
//   id: string;
//   name: string;
//   description?: string;
//   created_at?: string;
//   updated_at?: string;
// }

// export interface ServiceTypeDetail {
//   id: string;
//   name: string;
//   description?: string;
// }

// export interface CreateServicePayload {
//   description: string;
//   price: string;
//   vehicle_type: string;
//   price_model: string;
//   service_type_id: string;
//   from: string;
//   to: string;
// }

// export interface UpdateServicePayload {
//   status?: string;
//   description?: string;
//   price?: string;
//   vehicle_type?: string;
//   price_model?: string;
//   from?: string;
//   to?: string;
//   service_type_id?: string;
//   staff_members_id?: string[];
// }

// export interface CreateServiceResponse {
//   message: string;
//   data: any;
// }

// export interface UpdateServiceResponse {
//   message: string;
//   data: Service;
// }

// export interface DeleteServiceResponse {
//   message: string;
// }

// export const serviceApi = baseApi.injectEndpoints({
//   endpoints: (builder) => ({
//     getAllServiceTypes: builder.query<ServiceType[], void>({
//       query: () => ({
//         url: "/services/all-services/type",
//         method: "GET",
//       }),
//       transformResponse: (response: any) => {
//         return response?.data || [];
//       },
//       providesTags: ["service-types"],
//     }),

//     getServiceTypeById: builder.query<ServiceTypeDetail, string>({
//       query: (id) => ({
//         url: `/services/service-type/${id}`,
//         method: "GET",
//       }),
//       transformResponse: (response: any) => {
//         return response?.data || response;
//       },
//       providesTags: (result, error, id) => [{ type: "service-types", id }],
//     }),

//     getServiceById: builder.query<Service, string>({
//       query: (serviceId) => ({
//         url: `/services/by-id/${serviceId}`,
//         method: "GET",
//       }),
//       transformResponse: (response: any) => {
//         return response?.data?.data || response?.data || response;
//       },
//       providesTags: (result, error, id) => [{ type: "services", id }],
//     }),

//     getAllServicesList: builder.query<
//       GetAllServicesResponse,
//       { companyId: string; page?: number; per_page?: number; search?: string; type?: string }
//     >({
//       query: ({ companyId, page = 1, per_page = 10, search, type }) => {
//         const params = new URLSearchParams();
//         params.append("company_id", companyId);
//         params.append("page", String(page));
//         params.append("per_page", String(per_page));
//         if (search) params.append("search", search);
//         if (type) params.append("type", type);
//         return { url: `/services/all-services?${params.toString()}`, method: "GET" };
//       },
//       transformResponse: (response: any) => {
//         const level1 = response?.data;
//         const level2 = level1?.data;
//         return {
//           data: level2?.data || [],
//           links: level2?.links || { first: "", last: "", prev: null, next: null },
//           meta: level2?.meta || { current_page: 1, from: 0, last_page: 1, path: "", per_page: 10, to: 0, total: 0 },
//         };
//       },
//       providesTags: (result, error, arg) => {
//         const { companyId, page = 1, per_page = 10, search = "", type = "" } = arg;
//         return [
//           { type: "services", id: `LIST-${companyId}` },
//           { type: "services", id: `PAGE-${companyId}-${page}-${per_page}-${search}-${type}` },
//         ];
//       },
//       keepUnusedDataFor: 0,
//     }),

//     getAllServicesForSummary: builder.query<GetAllServicesResponse, { companyId: string }>({
//       query: ({ companyId }) => ({
//         url: `/services/all-services?company_id=${companyId}&page=1&per_page=10`,
//         method: "GET",
//       }),
//       transformResponse: (response: any) => {
//         const level1 = response?.data;
//         const level2 = level1?.data;
//         return {
//           data: level2?.data || [],
//           links: level2?.links || { first: "", last: "", prev: null, next: null },
//           meta: level2?.meta || { current_page: 1, from: 0, last_page: 1, path: "", per_page: 10, to: 0, total: 0 },
//         };
//       },
//       providesTags: (result, error, arg) => [{ type: "services-summary", id: arg.companyId }],
//       keepUnusedDataFor: 60,
//     }),

//     createService: builder.mutation<CreateServiceResponse, CreateServicePayload>({
//       query: (payload) => ({
//         url: "/services/create",
//         method: "POST",
//         body: payload,
//       }),
//       invalidatesTags: ["services", "services-summary"],
//     }),

//     updateService: builder.mutation<UpdateServiceResponse, { id: string; payload: UpdateServicePayload }>({
//       query: ({ id, payload }) => ({
//         url: `/services/update/${id}`,
//         method: "PATCH",
//         body: payload,
//       }),
//       transformResponse: (response: any) => ({
//         message: response?.message || "Service updated successfully",
//         data: response?.data || response,
//       }),
//       invalidatesTags: (result, error, { id }) => [
//         { type: "services", id: "LIST" },
//         "services-summary",
//         ...Array.from({ length: 100 }, (_, i) => ({
//           type: "services" as const,
//           id: `PAGE-${i + 1}-10--`,
//         })),
//       ],
//     }),

//     deleteService: builder.mutation<DeleteServiceResponse, string>({
//       query: (id) => ({
//         url: `/services/delete-service/${id}`,
//         method: "DELETE",
//       }),
//       transformResponse: (response: any) => ({
//         message: response?.message || "Service deleted successfully",
//       }),
 
//       invalidatesTags: (result, error, id) => [
//         { type: "services", id: "LIST" },
//         "services-summary",
//       ],
//     }),
//   }),
// });

// export const {
//   useGetAllServiceTypesQuery,
//   useGetServiceTypeByIdQuery,
//   useGetServiceByIdQuery,
//   useGetAllServicesListQuery,
//   useLazyGetAllServicesListQuery,
//   useGetAllServicesForSummaryQuery,
//   useCreateServiceMutation,
//   useUpdateServiceMutation,
//   useDeleteServiceMutation,
//   useLazyGetServiceTypeByIdQuery,
// } = serviceApi;


import { baseApi } from "./baseApi";

export interface ServiceRoute {
  id: string;
  service_id: string;
  from: string;
  to: string;
  price: string | number;
  vehicle_type?: string;
  staff_member_ids?: string[];
}

export interface Service {
  id: string;
  description: string;
  price: string;
  base_price: string;
  vehicle_type: string;
  price_model: string;
  from: string;
  to: string;
  service_type_name: string;
  service_type_id: string;
  created_at: string;
  status?: string;
  staff_members_id?: string[];
  routes?: ServiceRoute[];
}

export interface GetAllServicesResponse {
  data: Service[];
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
  };
}

export interface ServiceType {
  id: string;
  name: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ServiceTypeDetail {
  id: string;
  name: string;
  description?: string;
}

export interface CreateServicePayload {
  description: string;
  base_price?: string | number;
  vehicle_type: string;
  price_model: string;
  service_type_id: string;
  company_id: string;
  staff_members_id: string[];
  routes?: { from: string; to: string; price: number }[];
}

export interface UpdateServicePayload {
  status?: string;
  description?: string;
  price?: string;
  vehicle_type?: string;
  price_model?: string;
  from?: string;
  to?: string;
  service_type_id?: string;
  staff_members_id?: string[];
  routes?: { from: string; to: string; price: number }[];
}

export interface CreateServiceResponse {
  message: string;
  data: any;
}

export interface UpdateServiceResponse {
  message: string;
  data: Service;
}

export interface DeleteServiceResponse {
  message: string;
}

export const serviceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllServiceTypes: builder.query<ServiceType[], void>({
      query: () => ({
        url: "/services/all-services/type",
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response?.data || [];
      },
      providesTags: ["service-types"],
    }),

    getServiceTypeById: builder.query<ServiceTypeDetail, string>({
      query: (id) => ({
        url: `/services/service-type/${id}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response?.data || response;
      },
      providesTags: (result, error, id) => [{ type: "service-types", id }],
    }),

    getServiceById: builder.query<Service, string>({
      query: (serviceId) => ({
        url: `/services/by-id/${serviceId}`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return response?.data?.data || response?.data || response;
      },
      providesTags: (result, error, id) => [{ type: "services", id }],
    }),

    getAllServicesList: builder.query<
      GetAllServicesResponse,
      { companyId: string; page?: number; per_page?: number; search?: string; type?: string }
    >({
      query: ({ companyId, page = 1, per_page = 10, search, type }) => {
        const params = new URLSearchParams();
        params.append("company_id", companyId);
        params.append("page", String(page));
        params.append("per_page", String(per_page));
        if (search) params.append("search", search);
        if (type) params.append("type", type);
        return { url: `/services/all-services?${params.toString()}`, method: "GET" };
      },
      transformResponse: (response: any) => {
        const level1 = response?.data;
        const level2 = level1?.data;
        return {
          data: level2?.data || [],
          links: level2?.links || { first: "", last: "", prev: null, next: null },
          meta: level2?.meta || { current_page: 1, from: 0, last_page: 1, path: "", per_page: 10, to: 0, total: 0 },
        };
      },
      providesTags: (result, error, arg) => {
        const { companyId, page = 1, per_page = 10, search = "", type = "" } = arg;
        return [
          { type: "services", id: `LIST-${companyId}` },
          { type: "services", id: `PAGE-${companyId}-${page}-${per_page}-${search}-${type}` },
        ];
      },
      keepUnusedDataFor: 0,
    }),

    getAllServicesForSummary: builder.query<GetAllServicesResponse, { companyId: string }>({
      query: ({ companyId }) => ({
        url: `/services/all-services?company_id=${companyId}&page=1&per_page=10`,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        const level1 = response?.data;
        const level2 = level1?.data;
        return {
          data: level2?.data || [],
          links: level2?.links || { first: "", last: "", prev: null, next: null },
          meta: level2?.meta || { current_page: 1, from: 0, last_page: 1, path: "", per_page: 10, to: 0, total: 0 },
        };
      },
      providesTags: (result, error, arg) => [{ type: "services-summary", id: arg.companyId }],
      keepUnusedDataFor: 60,
    }),

    createService: builder.mutation<CreateServiceResponse, CreateServicePayload>({
      query: (payload) => ({
        url: "/services/create",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["planLimit", "services", "services-summary"],
    }),

    updateService: builder.mutation<UpdateServiceResponse, { id: string; payload: UpdateServicePayload }>({
      query: ({ id, payload }) => ({
        url: `/services/update/${id}`,
        method: "PATCH",
        body: payload,
      }),
      transformResponse: (response: any) => ({
        message: response?.message || "Service updated successfully",
        data: response?.data || response,
      }),
      invalidatesTags: (result, error, { id }) => [
        "planLimit",
        { type: "services", id: "LIST" },
        "services-summary",
        ...Array.from({ length: 100 }, (_, i) => ({
          type: "services" as const,
          id: `PAGE-${i + 1}-10--`,
        })),
      ],
    }),

    deleteService: builder.mutation<DeleteServiceResponse, string>({
      query: (id) => ({
        url: `/services/delete-service/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response: any) => ({
        message: response?.message || "Service deleted successfully",
      }),
      invalidatesTags: (result, error, id) => [
        "planLimit",
        { type: "services", id: "LIST" },
        "services-summary",
      ],
    }),
  }),
});

export const {
  useGetAllServiceTypesQuery,
  useGetServiceTypeByIdQuery,
  useGetServiceByIdQuery,
  useGetAllServicesListQuery,
  useLazyGetAllServicesListQuery,
  useGetAllServicesForSummaryQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useLazyGetServiceTypeByIdQuery,
} = serviceApi;